var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgJcb = _a => {
  var _b;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F6F6F6"
  }), React.createElement("rect", {
    x: 7,
    y: 12,
    width: 5.72,
    height: 8,
    fill: "white"
  }), React.createElement("rect", {
    x: 13.45,
    y: 12,
    width: 5.72,
    height: 8,
    fill: "white"
  }), React.createElement("rect", {
    x: 19.86,
    y: 12,
    width: 5.72,
    height: 8,
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01867 10.9871V22.8286V17.9848C7.01271 17.9833 7.00685 17.9818 7.0011 17.9803C7.00037 20.538 7 22.8286 7 22.8286C7 22.8286 9.6342 22.8286 10.5115 22.8286C11.4698 22.8286 12.7168 21.9396 12.7168 20.5875C12.7168 18.3183 12.7168 9.0083 12.7168 9.0083C12.7168 9.0083 10.1462 9.0083 9.25025 9.0083C8.16064 9.0083 7.15797 9.91388 7.01867 10.9871V17.0274C7.26748 17.1674 8.2625 17.4819 8.66865 17.5107C9.58076 17.5746 10.1462 17.2751 10.2337 16.5202L10.2293 13.7167H12.2472V16.4562C12.141 18.0253 10.7546 18.3452 8.6445 18.2394C8.10727 18.2126 7.37981 18.0767 7.01867 17.9848V10.9871Z",
    fill: "#1B6CA8"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.696 9C14.5215 9 13.448 10.0523 13.448 11.2324C13.448 11.6443 13.4476 12.827 13.4476 14.2882C14.1522 13.7415 15.2883 13.4736 16.7341 13.5841C17.5569 13.647 18.1652 13.7611 18.4971 13.8585V14.8283C18.1315 14.6473 17.4097 14.3776 16.808 14.3343C15.4442 14.2369 14.7287 14.8712 14.7287 15.8969C14.7287 16.8201 15.2814 17.6099 16.8018 17.5049C17.3032 17.47 18.1377 17.18 18.4928 17.012L18.4971 17.9531C18.1915 18.0487 17.2406 18.2544 16.3457 18.2617C14.9984 18.2726 14.0479 17.9883 13.4469 17.5274C13.4462 20.2582 13.4458 22.8203 13.4458 22.8203C13.4458 22.8203 16.08 22.8203 16.9573 22.8203C17.9156 22.8203 19.1626 21.9313 19.1626 20.5792C19.1626 18.31 19.1626 9 19.1626 9C19.1626 9 16.592 9 15.696 9Z",
    fill: "#D92243"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3597 16.191C21.975 16.1946 21.1365 16.1874 20.9846 16.191L20.9824 17.4119L22.3575 17.4166C22.6247 17.4166 22.9611 17.1891 22.9611 16.7929C22.9611 16.4425 22.6708 16.1881 22.3597 16.191Z",
    fill: "#5FB345"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7942 14.9657C22.7942 14.6154 22.5288 14.3787 22.247 14.3853C21.851 14.3944 21.1365 14.3755 20.9802 14.3893L20.9755 15.5011L22.2744 15.5102C22.4908 15.5059 22.7942 15.3092 22.7942 14.9657Z",
    fill: "#5FB345"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1086 9C20.9341 9 19.8606 10.0523 19.8606 11.2324C19.8606 11.5861 19.8606 12.5097 19.8602 13.6892H23.1983C23.8626 13.6892 24.6448 13.9716 24.6448 14.7734C24.6448 15.2038 24.4142 15.6908 23.5829 15.8486V15.8667C24.0683 15.8667 24.9097 16.1491 24.9097 17C24.9097 17.8782 24.0006 18.1224 23.5138 18.1224L19.8595 18.1261C19.8588 20.621 19.8584 22.8203 19.8584 22.8203C19.8584 22.8203 22.4926 22.8203 23.3699 22.8203C24.3282 22.8203 25.5755 21.9313 25.5755 20.5792C25.5755 18.31 25.5755 9 25.5755 9C25.5755 9 23.0046 9 22.1086 9Z",
    fill: "#5FB345"
  }));
};
export default SvgJcb;